precision mediump float;


uniform vec3 uColor; 

uniform vec3 cameraPosition;
uniform vec3 uPlaneColor; 
uniform vec3 uDepthColor; 
uniform vec3 uMiddleColor; 

uniform sampler2D uTexture;
uniform sampler2D uTextureVector;
uniform sampler2D uShadowsTexture;

uniform float uColorOffset;
uniform float uColorMultiplier;

varying vec2 vUv;
varying float vElevation;


void main()
{   
    float mixStrength = (vElevation - 0.009 )* 33.3;
    vec4 textureColor = texture2D(uTexture, vec2(1.0 - vUv.x, vUv.y));
    vec4 textureVectorColor = texture2D(uTextureVector, vec2(1.0 - vUv.x, vUv.y));
    vec4 shadowColor = texture2D(uShadowsTexture,  vec2(1.0 - vUv.x, vUv.y));
    vec3 baseColor = uPlaneColor * shadowColor.rgb;
    if (textureVectorColor.x > 0.5 )  {
        baseColor = mix(uDepthColor, uMiddleColor, mixStrength);
        baseColor *= (shadowColor.rgb * 0.9);
    }
    gl_FragColor = vec4(baseColor, 1.0);
}